import * as React from "react";
import { ListItem, Typography, Divider, Avatar } from "@material-ui/core";
import { Case, User, Category, Notification } from "../../api/classes";
import * as moment from "moment";
import { Link } from "react-router-dom";

interface Props {
  notification: Notification;
  cases: Case[];
  users: User[];
}
interface State {}
export default class NotificationItem extends React.Component<Props, State> {
  render() {
    return (
      <ListItem
        button
        style={{
          paddingTop: 0,
          paddingLeft: 0,
          paddingRight: 0,
          paddingBottom: 0,
          backgroundColor:
            this.props.notification.read === 0 ? "#f3fff2" : "transparent"
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column"
          }}
        >
          <Link
            to={this.URL}
            style={{
              textDecoration: "none",
              marginTop: 24,
              marginLeft: 24,
              marginRight: 24
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center"
              }}
            >
              <Typography variant="body1" style={{ flex: 1, fontSize: 16 }}>
                {this.notificationText}
              </Typography>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                marginBottom: 12,
                marginTop: 12
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  flex: 1
                }}
              >
                <Typography style={{}} variant="caption">
                  {moment(this.props.notification.createdAt).format(
                    "dddd, DD MMMM YYYY, HH:mm"
                  )}
                </Typography>
              </div>
            </div>
          </Link>
          <Divider />
        </div>
      </ListItem>
    );
  }
  getCaseName = case_id => {
    const find = this.props.cases.find(c => c.id === parseInt(case_id));
    return find ? find.title : "this case";
  };
  getUserName = user_id => {
    const find = this.props.users.find(c => c.id === parseInt(user_id));
    return find ? (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          marginRight: 4
        }}
      >
        <Avatar
          src={find.account_picture}
          style={{ width: 24, height: 24, marginRight: 4 }}
        />
        <span>{find.name}</span>
      </div>
    ) : (
      "Someone"
    );
  };
  get notificationText() {
    switch (this.props.notification.type) {
      case "CASE_ASSIGNED":
        console.log(this.props.notification.payload);
        if (this.props.notification.payload.version > 1) {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center"
              }}
            >
              <b>
                {this.getUserName(this.props.notification.payload.assigned_by)}
              </b>
              <span style={{ marginRight: 4 }}>{" assigned you to case "}</span>
              <b>{this.getCaseName(this.props.notification.payload.case_id)}</b>
            </div>
          );
        }
        return (
          <span>
            {"You are assigned to "}
            <b>{this.getCaseName(this.props.notification.payload.case_id)}</b>
          </span>
        );
      case "CASE_ACTIVITY":
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center"
            }}
          >
            <b>{this.getUserName(this.props.notification.payload.user_id)}</b>
            <span style={{ marginRight: 4 }}>{" added an activity for "}</span>
            <b>{this.getCaseName(this.props.notification.payload.case_id)}</b>
          </div>
        );
      case "CASE_EVIDENCE":
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center"
            }}
          >
            <b>{this.getUserName(this.props.notification.payload.user_id)}</b>
            <span style={{ marginRight: 4 }}>{" added an evidence for "}</span>
            <b>{this.getCaseName(this.props.notification.payload.case_id)}</b>
          </div>
        );
    }
    return "";
  }
  get URL() {
    switch (this.props.notification.type) {
      case "CASE_ASSIGNED":
      default:
        return "/case/" + this.props.notification.payload.case_id;
    }
    return "";
  }
}



// WEBPACK FOOTER //
// ./src/pages/notifications/notificationCard.tsx